import React from "react";
import { Link } from "react-router-dom";
import { mediaUrl } from "../lib/api";
import BlockchainBadge from "./BlockchainBadge";

function MediaIcons({ post }) {
  return (
    <span style={{ display: "inline-flex", gap: 6 }}>
      {post.audio_url && <span title="audio" aria-label="audio">♪</span>}
      {post.video_url && <span title="video" aria-label="video">▶</span>}
      {post.cover_image_url && <span title="image" aria-label="image">◼</span>}
    </span>
  );
}

export default function PostCard({ post }) {
  const date = post.published_at
    ? new Date(post.published_at).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })
    : "draft";
  return (
    <Link
      to={`/articles/${post.slug}`}
      className="xs-card"
      data-testid={`post-card-${post.slug}`}
    >
      {post.cover_image_url && (
        <img
          src={mediaUrl(post.cover_image_url)}
          alt=""
          className="xs-card-cover"
          loading="lazy"
        />
      )}
      <div className="xs-card-body">
        <h3 className="xs-card-title">{post.title}</h3>
        {post.excerpt && <p className="xs-card-excerpt">{post.excerpt}</p>}
        <div className="xs-card-meta">
          <span>{date}</span>
          <MediaIcons post={post} />
          {post.tags?.slice(0, 2).map((t) => (
            <span key={t} className="xs-tag">#{t}</span>
          ))}
          <BlockchainBadge
            hash={post.blockchain_hash}
            status={post.opentimestamps_status}
            compact
          />
        </div>
      </div>
    </Link>
  );
}
